import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { spacingsTemplate, typographyTemplate, bordersTemplate, useToken } from '@equinor/eds-utils';
import { token } from './HeaderCell.tokens.js';
import { jsx } from 'react/jsx-runtime';
import { useEds } from '../../EdsProvider/eds.context.js';

var _excluded = ["children", "sort", "sticky"];
var StyledTableCell = styled.th.withConfig({
  displayName: "HeaderCell__StyledTableCell",
  componentId: "sc-18w2o3a-0"
})(function (props) {
  var theme = props.theme,
    $sticky = props.$sticky;
  var background = theme.background,
    height = theme.height,
    typography = theme.typography,
    spacings = theme.spacings;
  var activeToken = theme.states.active;
  var ariaSort = props['aria-sort'];
  var sortStylingHover = css({});
  var sortStylingActive = css({});
  if (ariaSort) {
    sortStylingHover = css(["@media (hover:hover) and (pointer:fine){&:hover{cursor:pointer;background:", ";}}"], theme.states.hover.background);
  }
  if (ariaSort && ariaSort !== 'none') {
    sortStylingActive = css(["", ";background:", ";color:", ";"], activeToken.border.type === 'bordergroup' ? css(["border-color:", ";"], activeToken.border.bottom.color) : '', activeToken.background, activeToken.typography.color);
  }
  return css(["min-height:", ";height:", ";background:", ";box-sizing:border-box;", " ", " ", " ", " ", " ", ""], height, height, background, spacingsTemplate(spacings), typographyTemplate(typography), bordersTemplate(theme.border), sortStylingHover, sortStylingActive, $sticky ? css(["position:sticky;top:0;z-index:1;"]) : '');
});
var CellInner = styled.div.withConfig({
  displayName: "HeaderCell__CellInner",
  componentId: "sc-18w2o3a-1"
})(["display:flex;align-items:center;"]);
var TableHeaderCell = /*#__PURE__*/forwardRef(function TableHeaderCell(_ref, ref) {
  var children = _ref.children,
    sort = _ref.sort,
    sticky = _ref.sticky,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useEds = useEds(),
    density = _useEds.density;
  var token$1 = useToken({
    density: density
  }, token);
  var props = _objectSpread({
    ref: ref,
    $sticky: sticky
  }, rest);
  return /*#__PURE__*/jsx(ThemeProvider, {
    theme: token$1,
    children: /*#__PURE__*/jsx(StyledTableCell, _objectSpread(_objectSpread({
      "aria-sort": sort
    }, props), {}, {
      children: /*#__PURE__*/jsx(CellInner, {
        children: children
      })
    }))
  });
});

export { TableHeaderCell };
